import * as React from "react"
import { cn } from "@/lib/utils"

const Label = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <label
      ref={ref}
      className={cn(
        "text-xs font-extrabold tracking-widest uppercase text-gold peer-disabled:opacity-60",
        className
      )}
      {...props}
    />
  )
})
Label.displayName = "Label"

export { Label }
